import { get } from 'underscore'
import axios from './HTTP'

export default {
  create(event) {
    return axios.post(`/api/events.json`, event)
      .then(r => {
        return r
      })
      .catch(e => {
        throw e
      })
  },

  get(eventId) {
    return axios.get(`/api/events/${ eventId }.json`)
      .then(r => {
        return r
      })
      .catch(e => {
        throw e
      })
  },

  getAll() {
    return axios.get(`/api/events.json`)
      .then(r => {
        return r
      })
      .catch(e => {
        throw e
      })
  },

  update(eventId, event) {
    return axios.patch(`/api/events/${ eventId }.json`, event)
      .then(r => {
        return r
      })
      .catch(e => {
        throw e
      })
  },

  destroy(eventId) {
    return axios.delete(`/api/events/${ eventId }.json`)
      .then(r => {
        return r
      })
      .catch(e => {
        throw e
      })
  },

}
